export { default } from './ProductLayout';
